import { useCallback, useState } from 'react';
import { FALLBACK_ANNOUNCEMENT_ATTRIBUTES } from './actions';
import { AnnouncementAttributesReturnType, IAnnouncementAttribute } from './types';

// Schema atributelor de anunț (subtitlu / descriere / prioritate) e LOCALĂ: BE nu expune
// `api/announcements/attributes`. Builder-ul de formular o folosește direct; layout-ul
// tabelului vine separat, din table-config. `getAttributes` rămâne pentru compatibilitatea
// consumatorilor, dar întoarce mereu schema locală (fără request de rețea).
export function useAnnouncementAttributes(
	_getOnRender: boolean | undefined = undefined
): AnnouncementAttributesReturnType {
	const [data] = useState<IAnnouncementAttribute[]>(FALLBACK_ANNOUNCEMENT_ATTRIBUTES);

	const getAttributes = useCallback(
		async () => FALLBACK_ANNOUNCEMENT_ATTRIBUTES,
		[]
	);

	return { data, loading: false, getAttributes };
}
